export class PayrollCounts {
  tenantId: string;
  payDay: Date;
  closedPayrollCount: number;
  expectedPayrollCount: number;
  closeAndNotScheduledPayrollCount: number;
  inProgressAndNotScheduledPayrollCount: number;
  inProgressPayrollCount: number;
  scheduledPayrollCount: number;
}
